export default __webpack_public_path__ + "static/media/gallery_05.642c4bca.jpg";